/**
 * Groups the source array by the provided property.
 *
 * @param {Array} sourceArray - The array to group.
 * @param {String} groupByPropName - The property whose value decides the group.
 *
 * @returns {Array} One `{ [groupByPropName], items }` per distinct value, the property
 *   itself removed from each item. Undefined if no array was given.
 */

export default (sourceArray, groupByPropName) => {
  if (!sourceArray) return undefined;

  // A Map rather than a lookup over the accumulator: the array form re-scanned and
  // re-spread the whole accumulator per element, which is quadratic in the row count.
  const groups = new Map();

  sourceArray.forEach((element) => {
    const key = element[groupByPropName];

    if (!groups.has(key)) {
      groups.set(key, { [groupByPropName]: key, items: [] });
    }

    const item = { ...element };
    delete item[groupByPropName];
    groups.get(key).items.push(item);
  });

  return [...groups.values()];
};
